// extracted by mini-css-extract-plugin
export default {"root":"VjdcKlajFpQ0RLT0HyHQ","loader":"p3QzFv2sPUqkroEC33bc","placeHolderShimmer":"VmT9Ijzy0dC5ARW94xS1"};